import { IRole } from './role';

export interface IApplication {
    roles: IRole[];
    applicationCode: string;
}
